import React from 'react';

import ProjectReports from './ProjectReports';
import { useProject } from '../../hooks/useProject';
import { ProjectPage } from './ProjectPage';
import { FormBase } from '../Interface';

export const ProjectMain = (props) => {
  const projectState = useProject();

  return (
    <FormBase
      name="project"
      leftPanelContent={<ProjectPage {...props} projectState={projectState} />}
      rightPanelContent={<> {!projectState.isLoading && <ProjectReports projectState={projectState} />}</>}
    />
  );
};
